// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .tenant-administrator-account-profile-container{
        width: 40vw;
        padding: 5px 10px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-account-profile-header{
        display: flex;
        justify-content: space-between;
    }
    .tenant-administrator-account-profile-header div h1{
        margin: 0px 5px;
        font-weight: 500;
        font-size: 24px;
        color: rgb(90, 90, 90);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-account-profile-header div h2{
        margin: 0px 5px;
        font-weight: 400;
        font-size: 18px;
        color: rgb(110, 110, 110);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-account-profile-entry-container{
        margin: 20px 0px;
        padding: 4px 10px;
        box-sizing: border-box;
        background-color: rgba(222, 229, 233, 0.6);
        border-bottom: 1px solid rgb(128, 128, 128);
    }
    .tenant-administrator-account-profile-entry-container:focus-within{
        border-bottom: 1px solid rgba(155, 30, 30, 0.952);
    }
    .tenant-administrator-account-profile-entry-container p{
        margin: 0px;
        font-size: 12px;
        color: rgb(88, 88, 88);
    }
    .tenant-administrator-account-profile-entry-container span{
        color: red;
    }
    .tenant-administrator-account-profile-entry-container input{
        width: 100%;
        outline: none;
        border: none;
        cursor: default;
        background-color: transparent;
    }
}
@media screen and (max-width:949px){
    .tenant-administrator-account-profile-container{
        width: auto;
        padding: 5px 10px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-account-profile-header{
        display: flex;
        justify-content: space-between;
    }
    .tenant-administrator-account-profile-header div h1{
        margin: 0px 5px;
        font-weight: 500;
        font-size: 24px;
        color: rgb(90, 90, 90);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-account-profile-header div h2{
        margin: 0px 5px;
        font-weight: 400;
        font-size: 18px;
        color: rgb(110, 110, 110);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-account-profile-entry-container{
        margin: 20px 0px;
        padding: 4px 10px;
        box-sizing: border-box;
        background-color: rgba(222, 229, 233, 0.6);
        border-bottom: 1px solid rgb(128, 128, 128);
    }
    .tenant-administrator-account-profile-entry-container:focus-within{
        border-bottom: 1px solid rgba(155, 30, 30, 0.952);
    }
    .tenant-administrator-account-profile-entry-container p{
        margin: 0px;
        font-size: 12px;
        color: rgb(88, 88, 88);
    }
    .tenant-administrator-account-profile-entry-container span{
        color: red;
    }
    .tenant-administrator-account-profile-entry-container input{
        width: 100%;
        outline: none;
        border: none;
        cursor: default;
        background-color: transparent;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Accounts/Profile.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,4DAA4D;IAChE;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,yBAAyB;QACzB,4DAA4D;IAChE;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,0CAA0C;QAC1C,2CAA2C;IAC/C;IACA;QACI,iDAAiD;IACrD;IACA;QACI,WAAW;QACX,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,eAAe;QACf,6BAA6B;IACjC;AACJ;AACA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,4DAA4D;IAChE;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,yBAAyB;QACzB,4DAA4D;IAChE;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,0CAA0C;QAC1C,2CAA2C;IAC/C;IACA;QACI,iDAAiD;IACrD;IACA;QACI,WAAW;QACX,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,eAAe;QACf,6BAA6B;IACjC;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .tenant-administrator-account-profile-container{\n        width: 40vw;\n        padding: 5px 10px;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-account-profile-header{\n        display: flex;\n        justify-content: space-between;\n    }\n    .tenant-administrator-account-profile-header div h1{\n        margin: 0px 5px;\n        font-weight: 500;\n        font-size: 24px;\n        color: rgb(90, 90, 90);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-account-profile-header div h2{\n        margin: 0px 5px;\n        font-weight: 400;\n        font-size: 18px;\n        color: rgb(110, 110, 110);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-account-profile-entry-container{\n        margin: 20px 0px;\n        padding: 4px 10px;\n        box-sizing: border-box;\n        background-color: rgba(222, 229, 233, 0.6);\n        border-bottom: 1px solid rgb(128, 128, 128);\n    }\n    .tenant-administrator-account-profile-entry-container:focus-within{\n        border-bottom: 1px solid rgba(155, 30, 30, 0.952);\n    }\n    .tenant-administrator-account-profile-entry-container p{\n        margin: 0px;\n        font-size: 12px;\n        color: rgb(88, 88, 88);\n    }\n    .tenant-administrator-account-profile-entry-container span{\n        color: red;\n    }\n    .tenant-administrator-account-profile-entry-container input{\n        width: 100%;\n        outline: none;\n        border: none;\n        cursor: default;\n        background-color: transparent;\n    }\n}\n@media screen and (max-width:949px){\n    .tenant-administrator-account-profile-container{\n        width: auto;\n        padding: 5px 10px;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-account-profile-header{\n        display: flex;\n        justify-content: space-between;\n    }\n    .tenant-administrator-account-profile-header div h1{\n        margin: 0px 5px;\n        font-weight: 500;\n        font-size: 24px;\n        color: rgb(90, 90, 90);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-account-profile-header div h2{\n        margin: 0px 5px;\n        font-weight: 400;\n        font-size: 18px;\n        color: rgb(110, 110, 110);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-account-profile-entry-container{\n        margin: 20px 0px;\n        padding: 4px 10px;\n        box-sizing: border-box;\n        background-color: rgba(222, 229, 233, 0.6);\n        border-bottom: 1px solid rgb(128, 128, 128);\n    }\n    .tenant-administrator-account-profile-entry-container:focus-within{\n        border-bottom: 1px solid rgba(155, 30, 30, 0.952);\n    }\n    .tenant-administrator-account-profile-entry-container p{\n        margin: 0px;\n        font-size: 12px;\n        color: rgb(88, 88, 88);\n    }\n    .tenant-administrator-account-profile-entry-container span{\n        color: red;\n    }\n    .tenant-administrator-account-profile-entry-container input{\n        width: 100%;\n        outline: none;\n        border: none;\n        cursor: default;\n        background-color: transparent;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
